import { SignJWT } from "jose";

export async function generateZoomSdkJwtToken({
  sdkKey,
  sdkSecret,
  meetingNumber,
  role = 0,
}) {
  if (!sdkSecret || typeof sdkSecret !== "string" || sdkSecret.trim() === "") {
    throw new Error("sdkSecret is missing or empty");
  }

  if (!sdkKey || typeof sdkKey !== "string" || sdkKey.trim() === "") {
    throw new Error("sdkKey is missing or empty");
  }

  const now = Date.now();
  const issuedAt = now - 60000; // 1 minute ago
  const expirationTimeMs = issuedAt + 2 * 60 * 60 * 1000; // 2 hours
  const expirationTimeSec = Math.floor(expirationTimeMs / 1000);

  const payload = {
    sdkKey: sdkKey.trim(),
    appKey: sdkKey.trim(),
    mn: meetingNumber,
    role: role,
    tokenExp: expirationTimeSec,
  };

  const secretKey = new TextEncoder().encode(sdkSecret.trim());

  const token = await new SignJWT(payload)
    .setProtectedHeader({ alg: "HS256", typ: "JWT" })
    .setIssuedAt(Math.floor(issuedAt / 1000))
    .setExpirationTime(expirationTimeSec)
    .sign(secretKey);

  return token;
}

export const fakeData = {
  Users: ["test2", "test3", "test4", "test5", "test7"],
  schedule: {
    upcoming: [
      {
        formatted: "2025-11-25",
        format_match_time: "2025-11-25",
        SERIES_NAME: "Data Structures and Algorithms",
        GAME_INFO: "Searching and Sorting Algorithms",
        GAME_TYPE: "Bubble Sort, Selection Sort, Insertion Sort",
        datetime: "25/11/2025 10:00 AM",
        GAME_DATE: 1764036000,
        GAME_TIME: 1764036000,
        GAME_END_TIME: 0,
        TEAM1: "Sunrise High School",
        TEAM2: "Greenfield Academy",
        TEAM1IMAGE: "./assets/blank.png",
        TEAM2IMAGE: "./assets/blank.png",
        TEAM1_COLOR: "#FF5733",
        TEAM2_COLOR: "#33C1FF",
        VENUE: "City Sports Ground",
        CITY: "Tomorrow",
        COUNTRY: "India",
      },
      {
        formatted: "2025-12-20",
        format_match_time: "2025-12-20",
        SERIES_NAME: "Data Structures and Algorithms",
        GAME_INFO: "Searching and Sorting Algorithms",
        GAME_TYPE: "Merge Sort, Quick Sort, Counting Sort, Radix Sort",
        datetime: "20/12/2025 07:00 PM",
        GAME_DATE: 1766221200,
        GAME_TIME: 1766221200,
        GAME_END_TIME: 0,
        TEAM1: "St. Xavier's School",
        TEAM2: "Delhi Public School",
        TEAM1IMAGE: "./assets/blank.png",
        TEAM2IMAGE: "./assets/blank.png",
        TEAM1_COLOR: "#800000",
        TEAM2_COLOR: "#FFD700",
        VENUE: "School Cricket Ground",
        CITY: "Ahmedabad",
        COUNTRY: "India",
      },
      {
        formatted: "2025-12-25",
        format_match_time: "2025-12-25",
        SERIES_NAME: "Data Structures and Algorithms",
        GAME_INFO: "Greedy Algorithms",
        GAME_TYPE:
          "Introduction to Greedy Algorithms, Basics of Greedy and Proofs, Chopsticks Problem",
        datetime: "25/12/2025 02:00 PM",
        GAME_DATE: 1766566800,
        GAME_TIME: 1766566800,
        GAME_END_TIME: 0,
        TEAM1: "North Zone School",
        TEAM2: "South Zone School",
        TEAM1IMAGE: "./assets/blank.png",
        TEAM2IMAGE: "./assets/blank.png",
        TEAM1_COLOR: "#B22222",
        TEAM2_COLOR: "#006400",
        VENUE: "Community Sports Hall",
        CITY: "Jaipur",
        COUNTRY: "India",
      },
      {
        formatted: "2026-01-15",
        format_match_time: "2026-01-15",
        SERIES_NAME: "Data Structures and Algorithms",
        GAME_INFO: "Greedy Algorithms",
        GAME_TYPE:
          "Evacuate to Moon Problem, Snakes and Moongose Problem, Maximum Score Problem",
        datetime: "15/01/2026 09:00 AM",
        GAME_DATE: 1768455000,
        GAME_TIME: 1768455000,
        GAME_END_TIME: 0,
        TEAM1: "Karnataka Public School",
        TEAM2: "Tamil Nadu Academy",
        TEAM1IMAGE: "./assets/blank.png",
        TEAM2IMAGE: "./assets/blank.png",
        TEAM1_COLOR: "#006400",
        TEAM2_COLOR: "#4B0082",
        VENUE: "School Gymnasium",
        CITY: "Bengaluru",
        COUNTRY: "India",
      },
      {
        formatted: "2026-02-26",
        format_match_time: "2026-02-26",
        SERIES_NAME: "Data Structures and Algorithms",
        GAME_INFO: "Two Pointers and Sliding Window Technique",
        GAME_TYPE:
          "Two Pointers Technique, Sliding Window Technique, Remove duplicates from a sorted array",
        datetime: "26/02/2026 09:30 AM",
        GAME_DATE: 1772043600,
        GAME_TIME: 1772043600,
        GAME_END_TIME: 0,
        TEAM1: "Mumbai Public School",
        TEAM2: "Delhi Academy",
        TEAM1IMAGE: "./assets/blank.png",
        TEAM2IMAGE: "./assets/blank.png",
        TEAM1_COLOR: "#003366",
        TEAM2_COLOR: "#8B0000",
        VENUE: "School Hockey Field",
        CITY: "Mumbai",
        COUNTRY: "India",
      },
      {
        formatted: "2026-02-26",
        format_match_time: "2026-02-26",
        SERIES_NAME: "Data Structures and Algorithms",
        GAME_INFO: "Two Pointers and Sliding Window Technique",
        GAME_TYPE:
          "Find if absolute difference of two elements equals B, Find common elements in two arrays, Minimum Similar Substring",
        datetime: "26/02/2026 09:30 AM",
        GAME_DATE: 1772043600,
        GAME_TIME: 1772043600,
        GAME_END_TIME: 0,
        TEAM1: "Mumbai Public School",
        TEAM2: "Delhi Academy",
        TEAM1IMAGE: "./assets/blank.png",
        TEAM2IMAGE: "./assets/blank.png",
        TEAM1_COLOR: "#006400",
        TEAM2_COLOR: "#4B0082",
        VENUE: "School Hockey Field",
        CITY: "Mumbai",
        COUNTRY: "India",
      },
      {
        formatted: "2026-02-26",
        format_match_time: "2026-02-26",
        SERIES_NAME: "Data Structures and Algorithms",
        GAME_INFO: "Two Pointers and Sliding Window Technique",
        GAME_TYPE: "Palindrome by Splitting, More practice problems",
        datetime: "26/02/2026 09:30 AM",
        GAME_DATE: 1772043600,
        GAME_TIME: 1772043600,
        GAME_END_TIME: 0,
        TEAM1: "Mumbai Public School",
        TEAM2: "Delhi Academy",
        TEAM1IMAGE: "./assets/blank.png",
        TEAM2IMAGE: "./assets/blank.png",
        TEAM1_COLOR: "#B22222",
        TEAM2_COLOR: "#006400",
        VENUE: "School Hockey Field",
        CITY: "Mumbai",
        COUNTRY: "India",
      },
      {
        formatted: "2026-02-26",
        format_match_time: "2026-02-26",
        SERIES_NAME: "Data Structures and Algorithms",
        GAME_INFO: "Prefix Sum Problems",
        GAME_TYPE:
          "Creating Prefix Array, Optimizations using Prefix Sum, Suffix Arrays",
        datetime: "26/02/2026 09:30 AM",
        GAME_DATE: 1772043600,
        GAME_TIME: 1772043600,
        GAME_END_TIME: 0,
        TEAM1: "Mumbai Public School",
        TEAM2: "Delhi Academy",
        TEAM1IMAGE: "./assets/blank.png",
        TEAM2IMAGE: "./assets/blank.png",
        TEAM1_COLOR: "#003366",
        TEAM2_COLOR: "#8B0000",
        VENUE: "School Hockey Field",
        CITY: "Mumbai",
        COUNTRY: "India",
      },
      {
        formatted: "2026-02-26",
        format_match_time: "2026-02-26",
        SERIES_NAME: "Data Structures and Algorithms",
        GAME_INFO: "Prefix Sum Problems",
        GAME_TYPE:
          "Good Subarrays problem, Counting Pretty Numbers problem, Mystical Numbers problem",
        datetime: "26/02/2026 09:30 AM",
        GAME_DATE: 1772043600,
        GAME_TIME: 1772043600,
        GAME_END_TIME: 0,
        TEAM1: "Mumbai Public School",
        TEAM2: "Delhi Academy",
        TEAM1IMAGE: "./assets/blank.png",
        TEAM2IMAGE: "./assets/blank.png",
        TEAM1_COLOR: "#800000",
        TEAM2_COLOR: "#FFD700",
        VENUE: "School Hockey Field",
        CITY: "Mumbai",
        COUNTRY: "India",
      },
    ],
    live: [],
  },
  meetings: [
    {
      meetingNumber: "3703700011",
      passWord: "1212",
      sdkKey: "ImcpQL0WSzmkmeQOtnzFqA",
      sdkSecret: "DnVd8C1Oa1DuHtVNK1TzlPJRbJk8psdT",
    },
  ],
  messages: {},
};

export const generateWebToken = async (meetingIdx, username) => {
  const selectedMeeting = fakeData.meetings[meetingIdx];
  const jwt = await generateZoomSdkJwtToken({
    sdkKey: selectedMeeting.sdkKey,
    sdkSecret: selectedMeeting.sdkSecret,
    meetingNumber: selectedMeeting.meetingNumber,
    role: 0,
  });

  return {
    web: {
      meetingNumber: selectedMeeting.meetingNumber,
      passWord: selectedMeeting.passWord,
      signature: jwt,
      sdkKey: selectedMeeting.sdkKey,
      zak: "",
      userEmail: "multiapp@streaming.com",
      userName: username,
    },
  };
};

export const genarateAndroidToken = async (meetingIdx, username) => {
  const selectedMeeting = fakeData.meetings[meetingIdx];
  const jwt = await generateZoomSdkJwtToken({
    sdkKey: selectedMeeting.sdkKey,
    sdkSecret: selectedMeeting.sdkSecret,
    meetingNumber: selectedMeeting.meetingNumber,
    role: 0,
  });

  const rawJson = {
    android: {
      app: {
        mediaRecorderAudioSource: 7,
        fixturesHtml: "",
        onMeetingAdvertisementText: "",
        enableWatermark: false,
        noTitlebar: true,
        watermarkDelay: 30000,
        isSensorOrientationEnabledWhenForced: false,
        zoomCloudRecordingsUrl: "https://us02web.zoom.us/recording",
        notice: "Welcome to MyApp",
      },
      reflection: {
        InMeetingVideoController: {},
        InMeetingAudioController: {},
        InMeetingService: {},
        ZoomSDKInitParams: {
          autoRetryVerifyApp: true,
          enableLog: false,
          jwtToken: jwt,
        },
        JoinMeetingOptions: {
          no_bottom_toolbar: true,
          no_driving_mode: true,
        },
        InMeetingWhiteboardController: {},
        MeetingSettingsHelper: {
          setHideNoVideoUsersEnabled: true,
        },
        InMeetingAICompanionController: {},
        InMeetingChatController: {},
        InMeetingShareController: {},
        JoinMeetingParams: {
          meetingNo: selectedMeeting.meetingNumber,
          password: selectedMeeting.passWord,
          displayName: username,
        },
        ZoomUIService: {},
      },
      user: {
        autoLogoutApplicable: true,
        expiryNotice: "Your account is expiring in 10 days",
        username: username,
      },
      meeting: {
        backgroundUrl: "",
        isAudioBroadcast: false,
        contactInfo: "",
        colorHostUsersBackground: "",
        muteDelay: 500,
        isHost: false,
        usersViewSize: "30,18,6,20,50",
        blockedAudioSourceTypes: "1,2,3",
        usersFlexboxProps: "0,1,4,2",
        notice: "",
        enableBlockAudioSourceTypes: false,
        notListeningAudioSourceTypes: "",
        isHostOfAudioBroadcastWithFeedback: false,
        logoUrl: "",
        colorDark: "",
        isVideoMeeting: true,
        isEnableEarSpeakerListen: false,
        isAudioBroadcastWithFeedback: false,
        doLocalRecording: false,
        name: "Live Meeting",
        isAudioMeeting: false,
        localRecordingDays: 3,
        isAudioMeetingCanSpeak: true,
        animatedAudio: true,
        colorLight: "",
        showGuarantorName: true,
      },
    },
  };

  // Convert rawJson to Base64 string
  const base64Encoded = btoa(JSON.stringify(rawJson));

  return {
    rawJson,
    base64: base64Encoded,
  };
};

export const generateIosToken = async (meetingIdx, username) => {
  const selectedMeeting = fakeData.meetings[meetingIdx];
  const jwt = await generateZoomSdkJwtToken({
    sdkKey: selectedMeeting.sdkKey,
    sdkSecret: selectedMeeting.sdkSecret,
    meetingNumber: selectedMeeting.meetingNumber,
    role: 0,
  });

  const rawJson = {
    ios: {
      app: {
        onMeetingAdvertisementText: "", // keep if required
      },
      user: {
        autoLogoutApplicable: true,
      },
      meeting: {
        meetingNumber: selectedMeeting.meetingNumber,
        meetingPassword: selectedMeeting.passWord,
        jwt: jwt,

        userEmail: "test@streaming.com",
        userName: username,
      },
    },
  };

  // Convert rawJson to Base64 string
  const base64Encoded = btoa(JSON.stringify(rawJson));

  return {
    rawJson,
    base64: base64Encoded,
  };
};

// meetingNumber: "2707885874",
//   passWord: "634846",
//   sdkKey: "LjbfalN3RTqzJyrdC0BZQ",
//   sdkSecret: "leEKUuogld5Owe7X16VTEgMgcmj2fSOr"
